import React from "react";

export interface IconDocumentProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconDocument: React.FC<IconDocumentProps> = ({
  width = 25,
  height = 34,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 34"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14.5833 9.03125V0H1.5625C0.696615 0 0 0.710547 0 1.59375V32.4062C0 33.2895 0.696615 34 1.5625 34H23.4375C24.3034 34 25 33.2895 25 32.4062V10.625H16.1458C15.2865 10.625 14.5833 9.90781 14.5833 9.03125ZM18.75 24.7031C18.75 25.1414 18.3984 25.5 17.9688 25.5H7.03125C6.60156 25.5 6.25 25.1414 6.25 24.7031V24.1719C6.25 23.7336 6.60156 23.375 7.03125 23.375H17.9688C18.3984 23.375 18.75 23.7336 18.75 24.1719V24.7031ZM18.75 20.4531C18.75 20.8914 18.3984 21.25 17.9688 21.25H7.03125C6.60156 21.25 6.25 20.8914 6.25 20.4531V19.9219C6.25 19.4836 6.60156 19.125 7.03125 19.125H17.9688C18.3984 19.125 18.75 19.4836 18.75 19.9219V20.4531ZM18.75 15.6719V16.2031C18.75 16.6414 18.3984 17 17.9688 17H7.03125C6.60156 17 6.25 16.6414 6.25 16.2031V15.6719C6.25 15.2336 6.60156 14.875 7.03125 14.875H17.9688C18.3984 14.875 18.75 15.2336 18.75 15.6719ZM25 8.09492V8.5H16.6667V0H17.0638C17.4805 0 17.8776 0.166016 18.1706 0.464844L24.5443 6.97266C24.8372 7.27148 25 7.67656 25 8.09492Z" />
  </svg>
);
